import { Observable } from 'rxjs';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { deDE, enUS, plPL, skSK } from '..';

export class TranslateLoaderOverrid implements TranslateLoader {
    getTranslation(lang: string): Observable<TranslationObject> {
        return new Observable((observer) => {
            switch (lang) {
                case 'en':
                    observer.next(enUS);
                    break;
                case 'de':
                    observer.next(deDE);
                    break;
                case 'sk':
                    observer.next(skSK);
                    break;
                case 'pl':
                    observer.next(plPL);
                    break;
            }
            observer.complete();
        });
    }
}
